import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DownloadService } from "../../shared/services/download.service";
import { saveAs } from "file-saver";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
@Component({
    standalone: false,
    selector: "app-download",
    templateUrl: "./download.component.html",
    styleUrl: "./download.component.scss"
})
export class DownloadComponent implements OnInit {
  user_id: any;
  isLoad: boolean = true;
  blob: Blob;

  constructor(
    private readonly downloadService: DownloadService,
    private readonly route: ActivatedRoute,
    private readonly httpClient: HttpClient
  ) {}
  ngOnInit(): void {
    this.route.params.subscribe((event) => {
      this.user_id = event.rrid;
    });
  }
  async downloadmsi() {
    this.isLoad = true;
    await this.downlaodfile();
    this.isLoad = false;
  }
  async downlaodfile() {
    const downlodApiUrl = environment.apiRoot + "api/Assests/downloadsetup";
    saveAs(downlodApiUrl, "DECKorate_setup.exe");
  }
}
